import React from 'react';
import { Search, Shield, Target, Code } from 'lucide-react';
import { CompetencyCard } from './CompetencyCard';
const competencies = [{
  title: 'OSINT Techniques',
  description: 'Advanced reconnaissance and intelligence gathering',
  icon: Search,
  projects: ['Social media intelligence platform', 'Dark web monitoring system'],
  tools: ['Maltego', 'Shodan', 'theHarvester', 'OSINT Framework', 'SpiderFoot'],
  achievements: ['Identified 50+ vulnerabilities through OSINT', 'Built automated OSINT pipeline']
}, {
  title: 'Security Frameworks',
  description: 'Compliance and security standard implementation',
  icon: Shield,
  projects: ['ISO 27001 certification program', 'NIST CSF adoption roadmap'],
  tools: ['NIST CSF', 'ISO 27001', 'CIS Controls', 'OWASP Top 10', 'MITRE ATT&CK'],
  achievements: ['Participated in the team for Fortune 500 compliance certification', 'Reduced audit time by 40%']
}, {
  title: 'Product Strategy',
  description: 'Security product development and go-to-market',
  icon: Target,
  projects: ['Threat detection platform launch', 'Security dashboard redesign'],
  tools: ['JIRA', 'Productboard', 'Amplitude', 'Mixpanel', 'Figma'],
  achievements: ['40% increase in user engagement', '3 successful product launches']
}, {
  title: 'Technical Skills',
  description: 'Security engineering and automation',
  icon: Code,
  projects: ['Automated security testing pipeline', 'Threat modeling framework'],
  tools: ['Python', 'JavaScript', 'Docker', 'Kubernetes', 'AWS', 'Burp Suite', 'Metasploit'],
  achievements: ['60% faster vulnerability detection', 'AI agentic evaluations and agent creations']
}];
export function CompetencyGrid() {
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-29">
      {competencies.map((comp, idx) => <CompetencyCard key={idx} {...comp} data-id="element-30" />)}
    </div>;
}